import React from 'react';
import IconButton, { IconButtonProps } from '@components/buttons/IconButton';

const CancelButton: React.FC<IconButtonProps> = (props) => (
  <IconButton {...props} icon="fa-remove" />
);

export default CancelButton;
